import { render, staticRenderFns } from "./HorseIndicators.vue?vue&type=template&id=330ae15a&scoped=true&"
import script from "./HorseIndicators.vue?vue&type=script&lang=js&"
export * from "./HorseIndicators.vue?vue&type=script&lang=js&"
import style0 from "./HorseIndicators.vue?vue&type=style&index=0&id=330ae15a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ae15a",
  null
  
)

export default component.exports